
<template>
  <div>
    <div class="navigation-wrapper" >
      <div ref="slider" class="keen-slider" :style= "[this.options.vertical ? {'height':' 35px'} : {}]">
       <slot></slot>
      </div>
      <button
       v-if="slider && this.options.arrows"
        @click="slider.prev()"
        :class="{
          arrow: true,
          'arrow--left': true,
          'arrow--disabled': current === 0,
        }"
      >
      </button>
      <button
        v-if="slider && this.options.arrows"
        @click="slider.next()"
        :class="{
          arrow: true,
          'arrow--right': true,
          'arrow--disabled': current === slider.track.details.slides.length - 1,
        }"
      >
      </button>
      <div v-if="slider && this.options.dots" class="dots">
      <button
        v-for="(_slide, idx) in dotHelper"
        @click="slider.moveToIdx(idx)"
        :class="{ dot: true, active: current === idx }"
        :key="idx"
      ></button>
    </div> 
    </div>
  </div>
</template>

<script>
import "keen-slider/keen-slider.min.css"
import KeenSlider from "keen-slider"

export default {
  name: "Slider",
  props: {
    options:  {
			type: Object,
			required: true
		},
  },
  computed: {
    dotHelper() {
      return this.slider ? [...Array(this.slider.track.details.slides.length).keys()] : []
    },
  },
  data() {
    return {
      current: 1,
      slider: null,
    }
  },
  mounted() {
    this.slider = new KeenSlider(this.$refs.slider, {
      initial: this.current,
      loop: this.options.autoplay,
      slides: {
        perView: this.options.slidesToShow,
      },
      slideChanged: (s) => {
        this.current = s.track.details.rel
      },
      vertical: this.options.vertical,
      breakpoints: this.options.breakpoints
    },
     [
        (slider) => {
          if(this.options.autoplay) {
            let timeout
            let mouseOver = false
            var seconds = this.options.autoplaySpeed;
            function clearNextTimeout() {
              clearTimeout(timeout)
            }
            function nextTimeout() {
              clearTimeout(timeout)
              if (mouseOver) return
              timeout = setTimeout(() => {
                slider.next()
              }, seconds)
            }
            
            slider.on("created", () => {
              slider.container.addEventListener("mouseover", () => {
                mouseOver = true
                clearNextTimeout()
              })
              slider.container.addEventListener("mouseout", () => {
                mouseOver = false
                nextTimeout()
              })
              nextTimeout()
            })
            slider.on("dragStarted", clearNextTimeout)
            slider.on("animationEnded", nextTimeout)
            slider.on("updated", nextTimeout)
          }
        },
      ]
    )
  },
  beforeDestroy() {
    if (this.slider) this.slider.destroy()
  },
}
</script>
